import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { WorkflowImportPreviewResponseDataSchema } from "schema"
import { z } from "zod"

// `file` is the raw .permutflow contents. The backend verifies the signature, decodes it, strips any
// reference that doesn't exist here, and returns a preview blueprint for the canvas to load as an
// unsaved draft. Nothing is persisted until the user saves the canvas.
type Variables = { file: string }

export function useImportWorkflowMutation() {
  return useMutation({
    mutationFn: async ({
      file,
    }: Variables): Promise<z.infer<typeof WorkflowImportPreviewResponseDataSchema>> => {
      const response = await axios.post("/workflows/import", { file })
      return response.data.data
    },
  })
}
